<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Cotización</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="isDataLoaded" class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('show', 'quotations')"
            :to="{ name: 'QuotationShow', params: { id: quotationId } }"
            class="btn base-button btn-neutral text-primary bg-white btn-sm"
            >Ver detalle
          </router-link>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <quotation-form
          v-if="canCreate"
          :campaign="campaign"
          :quotation="quotation"
          :quotation-id="quotationId"
          :producer="producer"
          :projection="quotation.projection"
          :user-name="userName"
          title="Editar Cotización"
          @confirm="confirmQuotation"
          @save="updateQuotation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import QuotationForm from './Forms/QuotationForm';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    QuotationForm,
  },

  data() {
    return {
      isDataLoaded: false,
      campaign: null,
      producer: null,
      quotationId: 0,
      quotation: null,
      userName: null,
    };
  },

  computed: {
    canCreate() {
      return this.campaign && this.producer;
    },
  },

  mounted() {
    let id = +this.$route.params.id;
    if (id) {
      this.quotationId = id;
      this.fetchQuotation();
    } else {
      this.$router.push({ name: 'QuotationsList' });
    }
  },

  methods: {
    fetchQuotation() {
      const params = {
        include: [
          'producer.distributor.seller',
          'campaign.articles',
          'state',
          'items.article',
          'projection',
          'user',
          'pictures',
        ],
      };

      this.$services
        .resource('quotations')
        .show(this.quotationId, params)
        .then((res) => res.data.data)
        .then((quotation) => {
          this.quotation = quotation;
          this.campaign = quotation.campaign;
          this.producer = quotation.producer;
          this.userName = quotation.user.name;
          this.projection = quotation.projection ? quotation.projection : null;
          this.isDataLoaded = true;
        });
    },

    updateQuotation(quotation) {
      this.$services
        .resource('quotations')
        .update(this.quotationId, quotation)
        .then((res) => res)
        .catch((model) => {
          this.quotation = null;
          this.isDataLoaded = false;
          this.fetchQuotation();
        });
    },

    confirmQuotation() {
      // redirigir al resumen de pedido
      this.$services
        .resource('quotations')
        .confirm(this.quotationId)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'La cotización fue confirmada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'QuotationShow', params: { id: this.quotationId } }));
        });
    },
  },
};
</script>

<style scoped>
.btn-neutral:hover {
  background: white !important;
  color: black !important;
}
</style>
